import apiClient, { endpoints, queryStringifyObject } from 'app/apiClient';
import t from 'app/translations';
import {
  call, put, takeLatest, all,
} from 'redux-saga/effects';
import {
  setServiceErrorNotification,
} from 'notifications/notificationsActions';
import {
  FETCH_APPLICATION_LIST_CONSTANTS_REQUEST,
  fetchConstantsSuccess,
  FETCH_APPLICATION_LIST_REQUEST,
  fetchApplicationListSuccess,
  FETCH_REGIONS_BY_NAME_REQUEST,
  fetchRegionsByNameSuccess,
} from './applicationsDashboardActions';

export const apiGetRequest = endpoint => apiClient.getRequest(endpoint);

export function* fetchConstants() {
  const constantsEndpoint = `${endpoints.constants}/STATUS`;

  try {
    const response = yield call(apiGetRequest, constantsEndpoint);
    yield put(fetchConstantsSuccess(response.data));
  } catch (error) {
    yield put(setServiceErrorNotification(t('Generic.fetchFailedConstants')));
  }
}

export function* fetchApplicationList(action) {
  const { filterConfig } = action.payload;
  const endpoint = `${endpoints.applicationList}/${queryStringifyObject({ ...filterConfig })}`;

  try {
    const response = yield call(apiGetRequest, endpoint, undefined);
    yield put(fetchApplicationListSuccess(response.data));
  } catch (e) {
    yield put(setServiceErrorNotification(e.message || t('Generic.fetchFailedApplications')));
  }
}

export function* fetchRegionsByName(action) {
  const { regionName } = action.payload;
  const endpoint = `${endpoints.regionsByName}${queryStringifyObject({ regionName })}`;
  try {
    const response = yield call(apiGetRequest, endpoint);
    yield put(fetchRegionsByNameSuccess(response.data));
  } catch (e) {
    yield put(setServiceErrorNotification(e.message || t('Generic.fetchFailedRegions')));
  }
}

export default function* applicationsDashboardSaga() {
  yield all([
    takeLatest(FETCH_APPLICATION_LIST_CONSTANTS_REQUEST, fetchConstants),
    takeLatest(FETCH_APPLICATION_LIST_REQUEST, fetchApplicationList),
    takeLatest(FETCH_REGIONS_BY_NAME_REQUEST, fetchRegionsByName),
  ]);
}
